
<template>
  <b-modal
    v-if="user"
    ref="modal"
    id="agUserModal"
    class="agModal"
    centered
    no-close-on-esc
    no-close-on-backdrop
    @keyup.enter.native="saveButton_click"
  >
    <template slot="modal-header">
      <h4 v-if="isEditing" class="agModal-title">Edit User</h4>
      <h4 v-else class="agModal-title">New User</h4>
    </template>
    <b-input-group size="md" prepend="Username">
      <b-input
        type="text"
        v-model="user.username"
        :disabled="isEditing"
        :state="hasError('username')"
      ></b-input>
    </b-input-group>
    <b-input-group size="md" prepend="Name">
      <b-input type="text" v-model="user.name" autocomplete="false" :state="hasError('name')"></b-input>
    </b-input-group>
    <b-input-group size="md" prepend="Password">
      <b-input type="password" v-model="user.password" autocomplete="false" :state="hasError('password')"></b-input>
    </b-input-group>
    <b-input-group size="md" prepend="Retype Password">
      <b-input type="password" v-model="retypePassword" autocomplete="false" :state="hasError('retypePassword')"></b-input>
    </b-input-group>
    <hr />
    <div class="agInputGroup agInputGroupCentered">
      <label>Role:</label>
      <b-form-select 
        class="agMediumInput"
        v-model="user.role" 
        :options="roles">
      </b-form-select>
    </div>
    <div v-if="modalMessage">
      <hr />
      <label class="agModal-message" :class="modalMessageClass">{{modalMessage}}</label>
    </div>
    <template slot="modal-footer" slot-scope="{cancel}">
      <b-button class="agModal-buttonLeft" @click="cancel">Cancel</b-button>
      <b-spinner v-if="isLoading" class="agModal-loadingSpinner"></b-spinner>
      <b-button
        class="agModal-buttonRight"
        variant="primary"
        @click="saveButton_click"
        :disabled="isLoading"
      >Save</b-button>
    </template>
  </b-modal>
</template>






<script>
// components

// modules
import Util from "src/util/util";

export default {
  name: "ag-user-modal",
  components: {},
  props: {
    user: Object
  },
  data() {
    return {
      isLoading: false,
      modalMessage: "",
      modalMessageClass: "",
      errorField: "",
      retypePassword: "",
      roles: ["admin", "read/write", "readonly"]
    };
  },

  computed: {
    isEditing() {
      if (this.user._id) return true;
      return false;
    },

    users() {
      return this.$store.state.userStore.users;
    }
  },
  watch: {},

  created() {},

  mounted() {},

  methods: {
    // UI Events

    async saveButton_click() {
      if (!this.validate()) {
        return;
      }

      // save
      this.isLoading = true;
      if (this.user._id) var func = "updateUser";
      else var func = "insertUser";

      var result = await this.$store.dispatch("userStore/" + func, {
        user: this.user
      });
      this.isLoading = false;
      if (result.data.success) {
        this.hide();
        this.$emit("savedUser");
      } else {
        this.modalMessage = result.data.error;
        this.modalMessageClass = "agModal-errorMessage";
      }
    },

    // emitted Events

    // other

    show() {
      setTimeout(() => {
        this.reset();
        this.$refs.modal.show();
      }, 250);
    },

    hide() {
      this.$refs.modal.hide();
    },

    reset() {
      this.modalMessage = "";
      this.modalMessageClass = "";
      this.errorField = "";
      this.retypePassword = this.user.password;
    },

    hasError(field) {
      if (field == this.errorField) {
        return false; // false = error
      }
      return null;
    },

    validate() {
      this.modalMessage = "";
      this.modalMessageClass = "";
      this.errorField = "";

      if (!this.user.username || this.user.username.length == 0) {
        this.modalMessage = "Username is required";
        this.modalMessageClass = "agModal-errorMessage";
        this.errorField = "username";
        return false;
      }
      var existing = this.users.find(a => a.username == this.user.username);
      if (existing && existing._id != this.user._id) {
        this.modalMessage =
          'A user with username "' + this.user.username + '" already exists';
        this.modalMessageClass = "agModal-errorMessage";
        this.errorField = "username";
        return false;
      }
      if (!this.user.name || this.user.name.length == 0) {
        this.modalMessage = "Name is required";
        this.modalMessageClass = "agModal-errorMessage";
        this.errorField = "name";
        return false;
      }
      if (
        (!this.user.password || this.user.password.length == 0) &&
        !existing
      ) {
        this.modalMessage = "Password is required";
        this.modalMessageClass = "agModal-errorMessage";
        this.errorField = "password";
        return false;
      }
      if (
        (!this.retypePassword || this.retypePassword.length == 0) &&
        !existing
      ) {
        this.modalMessage = "Please confirm your password";
        this.modalMessageClass = "agModal-errorMessage";
        this.errorField = "retypePassword";
        return false;
      }
      if (this.user.password != this.retypePassword) {
        this.modalMessage = "Passwords do not match";
        this.modalMessageClass = "agModal-errorMessage";
        this.errorField = "retypePassword";
        return false;
      }
      if (!this.user.role || this.user.role.length == 0) {
        this.modalMessage = "Role is required";
        this.modalMessageClass = "agModal-errorMessage";
        this.errorField = "role";
        return false;
      }
      return true;
    }
  }
};
</script>






<style scoped lang="css">
</style>



// WEBPACK FOOTER //
// src/components/user/UserModal.vue